var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"orange"},[_c('span',[_vm._v("©2005-2021小橙家教")]),_c('span',{staticStyle:{"margin-left":"10px"}},[_vm._v("蜀ICP备2020035072号")])])])
}]

export { render, staticRenderFns }